import { ABOUT_QUOTE } from "../mock";
import { Award, Zap, Globe2, Sparkles, Quote } from "lucide-react";
import AboutCollage from "./AboutCollage";
import AboutStats from "./AboutStats";

const FEATURES = [
  { icon: Zap, label: "Fast delivery", color: "bg-[#FFE14D]" },
  { icon: Award, label: "Clean code", color: "bg-[#B7F0BE]" },
  { icon: Globe2, label: "Global clients", color: "bg-[#B4D6F7]" },
  { icon: Sparkles, label: "Design-first", color: "bg-[#E9C3F5]" },
];

export default function About() {
  return (
    <section id="about" className="pt-20 md:pt-32 pb-6 md:pb-10 bg-white overflow-hidden" data-testid="about-section">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10 items-center">
          <div className="lg:col-span-6 reveal">
            <p className="text-xs tracking-[0.25em] uppercase text-neutral-500 mb-4">
              — About Me
            </p>
            <h2
              data-split="words"
              className="display text-[42px] sm:text-[56px] md:text-[72px] leading-[0.98] tracking-tight"
            >
              A freelancer who cares about the details.
            </h2>

            <p className="mt-6 text-neutral-700 text-[16px] md:text-[17px] leading-relaxed max-w-xl">
              I&apos;m a <b>WordPress, Shopify &amp; WooCommerce</b> developer based in
              India. For 5 years I&apos;ve turned napkin-ideas into polished,
              revenue-driving websites for founders across 5+ countries from a
              driving school in Australia to a dental clinic in Dubai. No bloated
              agencies, no jargon just clean design, clean code and results.
            </p>

            <div className="flex flex-wrap gap-2 mt-6">
              {FEATURES.map(({ icon: Icon, label, color }) => (
                <span
                  key={label}
                  className={`${color} inline-flex items-center gap-1.5 h-9 px-3.5 rounded-full text-sm font-medium`}
                >
                  <Icon size={14} /> {label}
                </span>
              ))}
            </div>

            <div className="mt-10 max-w-md" data-testid="about-quote">
              <Quote size={22} className="text-black fill-black mb-3" />
              <p className="text-[15px] text-neutral-700 leading-relaxed italic">
                {ABOUT_QUOTE}
              </p>
              <p className="handwritten text-3xl md:text-4xl mt-3 relative inline-block">
                <span className="relative z-10">Prince Khedkar</span>
                <span className="absolute left-0 right-0 bottom-1 h-2.5 bg-[#FFE14D] -z-0" />
              </p>
            </div>
          </div>

          <div className="lg:col-span-6 reveal pt-6 lg:pt-0">
            <AboutCollage />
          </div>
        </div>

        <div className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-12 gap-6 items-end mb-4">
          <div className="md:col-span-5 reveal">
            <h3 className="display text-[32px] sm:text-[40px] md:text-[48px] leading-[1.02]">
              Numbers that <br className="hidden md:block" /> speak for me.
            </h3>
          </div>
          <p className="md:col-span-5 md:col-start-8 text-neutral-600 text-[15px] leading-relaxed reveal">
            Every project ships fast, ranks well and keeps converting long after
            launch. Here&apos;s the track record so far.
          </p>
        </div>
        <AboutStats />
      </div>
    </section>
  );
}
